<template>
  <b-modal
    id="modal-workplace-can-advance"
    ref="canAdvanceModal"
    :title="workplaceCanAdvance.workplace_name ? `${workplaceCanAdvance.can_advance ? 'Habilitar' : 'Desabilitar'} (${workplaceCanAdvance.workplace_name})` : ''"
    hide-footer
    size="xs"
    centered
  >
    <div>
      <p v-if="workplaceCanAdvance.is_show_date === false">
        Você tem certeza?
      </p>
      <div v-if="workplaceCanAdvance.is_show_date === null">
        Deseja informar uma data limite do serviço de antecipação?
        <div class="d-flex mt-1">
          <b-button
            variant="danger"
            class="ml-1 w-50"
            :disabled="loading"
            @click="continueCanAdvance(false)"
          >Não</b-button>
          <b-button
            variant="primary"
            class="ml-1 w-50"
            :disabled="loading"
            @click="continueCanAdvance(true)"
          >Sim</b-button>
        </div>
      </div>
      <div v-else>
        <div
          v-if="workplaceCanAdvance.is_show_date"
          class="mb-1"
        >
          <label for="deadline-date">Data Limite</label>
          <b-form-datepicker
            id="deadline-date"
            v-model="workplaceCanAdvance.can_advanced_end_date_until"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="pt-BR"
            label-help=""
            label-no-date-selected="Selecione"
          />
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            variant="primary"
            class="ml-1 w-50"
            :disabled="loading"
            @click="editCanAdvance"
          >
            <span class="d-none d-sm-inline">
              {{ workplaceCanAdvance.can_advance ? 'Habilitar' : 'Desabilitar' }}
            </span>
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton, BFormDatepicker, BModal, VBModal,
} from 'bootstrap-vue'
import useWorkplaceCanAdvance from './useWorkplaceCanAdvance'

export default {
  components: {
    BButton,
    BFormDatepicker,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
  },
  setup(_, { emit }) {
    const {
      loading,
      canAdvanceModal,
      workplaceCanAdvance,
      show,
      continueCanAdvance,
      editCanAdvance,
    } = useWorkplaceCanAdvance(() => emit('refetch-data'))

    return {
      loading,
      canAdvanceModal,
      workplaceCanAdvance,
      show,
      continueCanAdvance,
      editCanAdvance,
    }
  },
}
</script>
